import { generateTextFromJsonString } from './generate-text.ts'

export type IsLengthValidOptions = {
  min?: number
  max?: number
}

export const isLengthValid = (
  jsonString: string | undefined,
  { min, max }: IsLengthValidOptions
) => {
  if (typeof jsonString !== 'string') {
    return false
  }

  const text = generateTextFromJsonString(jsonString)

  if (min && text.length < min) {
    return false
  }

  if (max && text.length > max) {
    return false
  }

  return true
}
